module.exports = "https://bin.bnbstatic.com/_next/static/images/chz-banner-cn-a656a756fd84902a9abf08ef99ab415a.jpg";